import React from 'react'
import classNames from 'classnames'
import arrow from 'media/select-arrow-black.svg'

type Props = {
  className?: string
  decorations?: boolean
  children: React.ReactNode
  autoComplete?: string
  id?: string
  value?: string
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void
}

const Select = ({ className, decorations = true, ...props }: Props) => {
  return (
    <div className="relative">
      <select
        className={classNames(
          'block',
          'w-full',
          'appearance-none',
          'type-17',
          {
            'border-green border-b-1': decorations,
          },
          className
        )}
        {...props}
      />
      {decorations && (
        <div className="flex items-center absolute right-0 top-0 bottom-0 z-20">
          <img className={classNames('w-8 ', {})} src={arrow} alt="" />
        </div>
      )}
    </div>
  )
}

export default Select
